angular.module('app.filters')
.filter('accessibility', () =>
    function(input) {
        const tags = [];
        if (input.is_ticketed) {
            tags.push('ticketed');
            if (input.free_variant !== 'none') {
                tags.push(`free: ${input.free_variant}`);
            }
        }
        if (input.is_private) { tags.push('private'); }
        if (tags.length > 0) {
            return tags.join(', ');
        } else {
            return 'public';
        }
    }
);


// WEBPACK FOOTER //
// ./filters/accessibility.js